import { memo, type PropsWithChildren, useMemo } from 'react';

import { type Board } from '@air/api/types';

import {
  type BoardDragItem,
  DNDMovableToBoardItem,
} from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import { DNDParentBoard } from '~/components/Shared/Drag/DNDParentBoard';
import DragType from '~/components/Shared/Drag/dragTypes';
import { DropHighlight } from '~/components/Shared/DropHighlight';
import { type BoardTableRowProps } from '~/components/TableView/BoardTableRow';
import { DROPHIGHLIGHT_STYLES, TABLE_ROW_HEIGHT } from '../ui';

type PrivateDraggableBoardTableRowContainerProps = {
  board: BoardTableRowProps<Board>['data'];
};

export const PrivateDraggableBoardTableRowContainer = memo(
  ({ children, board }: PropsWithChildren<PrivateDraggableBoardTableRowContainerProps>) => {
    const draggableItem: BoardDragItem = useMemo(() => ({ board, type: DragType.boardCard }), [board]);

    return (
      <DNDParentBoard dropLocation="board" board={board} style={{ height: TABLE_ROW_HEIGHT }}>
        <DropHighlight style={DROPHIGHLIGHT_STYLES} />
        <DNDMovableToBoardItem id={board.id} item={draggableItem}>
          {children}
        </DNDMovableToBoardItem>
      </DNDParentBoard>
    );
  },
);

PrivateDraggableBoardTableRowContainer.displayName = 'PrivateDraggableBoardTableRowContainer';
